import adminApiClient from './apiClient.js';

export const planosApi = {
  list: async () => {
    const { data } = await adminApiClient.get('/assinaturas/planos');
    return data;
  },
  create: async (payload) => {
    const { data } = await adminApiClient.post('/assinaturas/planos', payload);
    return data;
  },
  update: async (id, payload) => {
    const { data } = await adminApiClient.put(`/assinaturas/planos/${id}`, payload);
    return data;
  },
};

export default planosApi;
